import React, { useEffect, useState } from "react";
import CampSiteDetail from "./CampSiteDetail";
import { CampSite } from './types';
import axios from "axios";



interface CampSiteListProps {
  campsites: CampSite[];
  onEdit: (campsite: CampSite) => void;
  onView: (campsite: CampSite) => void;
  onDelete: (id: number) => void;

}

const CampSiteList: React.FC<CampSiteListProps> = ({ campsites, onEdit, onDelete, onView }) => {
  const [selectedCampSite, setSelectedCampSite] = useState<CampSite | null>(null);
  const [isMobile, setIsMobile] = useState(false);
  const token = localStorage.getItem('accessToken');

  const apiUrl = process.env.REACT_APP_API_URL;

  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this record?")) {
      try {
        const response = await axios.delete(`${apiUrl}/CampSite/deleteCampSite/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        console.log("Delete response from backend:", response.data);
        onDelete(id);
      } catch (error: any) {
        console.error("Error deleting campsite", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Response status:", error.response.status);
        }
      }
    }
  };

  const handleView = (campsite: CampSite) => {
    setSelectedCampSite(campsite);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="campsite-list">
      {selectedCampSite ? (
        <CampSiteDetail
          campsite={selectedCampSite}
          onEdit={onEdit}
          onDelete={onDelete}
          onClose={() => setSelectedCampSite(null)}
        />
      ) : (
        <>
          <div className="list-header">
            <span>Name</span>
            <span>Location</span>
            <span>Capacity</span>
            <span>Price</span>
          </div>
          <ul className="list-group">
            {campsites.map(campsite => (
              <li key={campsite.id} className="list-group-item">
                <div className="campsite-info">
                  <div className="campsite-field">
                    <span className="field-label">Name:</span>
                    <span><strong>{campsite.name}</strong></span>
                  </div>
                  <div className="campsite-field">
                    <span className="field-label">Location:</span>
                    <span>{campsite.location}</span>
                  </div>
                  <div className="campsite-field">
                    <span className="field-label">Capacity:</span>
                    <span>{campsite.capacity}</span>
                  </div>
                  <div className="campsite-field">
                    <span className="field-label">Price:</span>
                    <span>€{campsite.pricePerNight}</span>
                  </div>
                </div>
                {campsite.imageUrls && (
                  <div className="campsite-images">
                    {campsite.imageUrls
                      .sort((a, b) => (b.isMain ? 1 : -1))
                      .slice(0, isMobile ? 3 : campsite.imageUrls.length)
                      .map((image, index) => (
                        <div key={index} className="image-container">
                          <img
                            src={image.url}
                            alt={`Campsite ${index + 1}`}
                            className={`img-thumbnail ${image.isMain ? "border border-primary" : ""}`}
                          />
                      
                        </div>
                      ))}
                  </div>
                )}
                <div className="campsite-actions">
                  <button className="btn btn-sm btn-outline-primary me-2" onClick={() => onEdit(campsite)}>
                    <i className="fas fa-edit"></i> Edit
                  </button>
                  <button className="btn btn-sm btn-outline-danger me-2" onClick={() => handleDelete(campsite.id)}>
                    <i className="fas fa-trash-alt"></i> Delete
                  </button>
                  <button className="btn btn-sm btn-outline-info" onClick={() => handleView(campsite)}>
                    <i className="fas fa-eye"></i> View
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default CampSiteList;